import React from 'react';
import { Box, Container, Grid, Typography, Paper } from '@mui/material';
import SecurityIcon from '@mui/icons-material/Security';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import StarIcon from '@mui/icons-material/Star';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const WhyUs = () => {
  const { t } = useTranslation();

  const reasons = [
    {
      icon: SecurityIcon,
      title: t('whyUs.security.title'),
      description: t('whyUs.security.description'),
      delay: 0.2,
    },
    {
      icon: AccessTimeIcon,
      title: t('whyUs.service24.title'),
      description: t('whyUs.service24.description'),
      delay: 0.4,
    },
    {
      icon: StarIcon,
      title: t('whyUs.premium.title'),
      description: t('whyUs.premium.description'),
      delay: 0.6,
    },
    {
      icon: LocalAtmIcon,
      title: t('whyUs.pricing.title'),
      description: t('whyUs.pricing.description'),
      delay: 0.8,
    },
  ];

  return (
    <Box
      id="why-us"
      sx={{
        py: 8,
        backgroundColor: 'background.default',
      }}
    >
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <Typography
            variant="h2"
            align="center"
            sx={{
              mb: 6,
              fontWeight: 700,
              color: 'primary.main',
            }}
          >
            {t('whyUs.title')}
          </Typography>
        </motion.div>

        <Grid container spacing={4}>
          {reasons.map((reason, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: reason.delay }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    p: 4,
                    height: '100%',
                    backgroundColor: 'background.paper',
                    border: 1,
                    borderColor: 'divider',
                    '&:hover': {
                      borderColor: 'secondary.main',
                      transform: 'translateY(-8px)',
                      transition: 'all 0.3s ease-in-out',
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      mb: 2,
                    }}
                  >
                    <reason.icon
                      sx={{
                        fontSize: 40,
                        color: 'secondary.main',
                        mr: 2,
                      }}
                    />
                    <Typography variant="h5" component="h3" sx={{ fontWeight: 600 }}>
                      {reason.title}
                    </Typography>
                  </Box>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{
                      lineHeight: 1.7,
                    }}
                  >
                    {reason.description}
                  </Typography>
                </Paper>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default WhyUs; 